import { combineReducers } from 'redux';
import { createReducer } from 'typesafe-actions';

import { setDefaultSEOData, updateSEOData } from './actions';

import type { SeoData } from 'Seo-Types';
export const data = createReducer({} as SeoData).handleAction(
  [updateSEOData, setDefaultSEOData],
  (_state, action) => action.payload,
);

const seoReducer = combineReducers({
  data,
});

export default seoReducer;
export type SeoState = ReturnType<typeof seoReducer>;
